// import React from "react";
import { setTitle } from "../../helpers/MetaTag";
// import HomeBanner from "../../components/sections/front/sections/HomeBanner";
// import HomeHowItWorks from "../../components/sections/front/sections/HomeHowItWorks";
import { useEffect } from "react";
import LoadingFallback from "../../components/elements/LoadingFallback";
// import Pricing from "../../components/sections/front/sections/Pricing";
// import ChoosePlan from "./account/ChoosePlan";
// import HomeFaq from "../../components/sections/front/sections/HomeFaq";

const Home = () => {
  setTitle("Memory Doodle | Home");

  const shopifyUrl = process.env.REACT_APP_SHOPIFY_URL?.trim();

  useEffect(() => {
    if (!shopifyUrl) return;
    if (process.env.NODE_ENV === "development") {
      // Production sends "/" to the Shopify storefront; in dev that makes localhost unusable.
      return;
    }
    window.location.href = shopifyUrl;
  }, [shopifyUrl]);

  if (process.env.NODE_ENV === "development") {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center text-md-dark">
        <p className="mb-2 font-medium">Local development</p>
        <p className="mb-6 text-sm text-slate-600">
          On production, this page forwards visitors to the Shopify storefront. Here it stays on localhost so you can open app routes directly.
        </p>
        <div className="flex flex-col gap-3 text-sm">
          {shopifyUrl ? (
            <a className="text-md-blue underline" href={shopifyUrl} rel="noreferrer">
              Open Shopify storefront (login / marketing)
            </a>
          ) : null}
          <a className="text-md-blue underline" href="/dashboard">
            My Books (local)
          </a>
          <a className="text-md-blue underline" href="/signin">
            Sign in (redirects to Shopify if configured)
          </a>
        </div>
      </div>
    );
  }

  return (
    <>
      <LoadingFallback />
      {/* <HomeBanner />
      <HomeHowItWorks /> */}
      {/* <ChoosePlan fromHomePage /> */}
    </>
  );
};

export default Home;
